import React from 'react';
import { Card, CardContent } from '../ui/card';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export default function CategoryHeatmap({ categories, onCategoryClick }) {
  const getHeatColor = (score) => {
    if (score >= 0.7) return 'hsl(var(--success))';
    if (score >= 0.5) return 'hsl(var(--warning))';
    return 'hsl(var(--destructive))';
  };
  
  const getTrendIcon = (trend) => {
    if (trend === 'up') return <TrendingUp size={16} />;
    if (trend === 'down') return <TrendingDown size={16} />;
    return <Minus size={16} />;
  };
  
  return (
    <div style={{ 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '1rem'
    }}>
      {categories.map(cat => (
        <Card
          key={cat.id}
          onClick={() => onCategoryClick?.(cat.id)}
          className="cursor-pointer hover:shadow-lg transition-all"
          style={{
            background: 'hsl(var(--card))',
            border: '1px solid hsl(var(--border))',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          {/* Heat indicator bar */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: 4,
            background: getHeatColor(cat.compositeScore),
            opacity: 0.8
          }} />
          
          <CardContent className="pt-6 pb-4 px-4">
            <div className="mb-2">
              <div style={{ 
                fontSize: '0.875rem', 
                fontWeight: 600,
                color: 'hsl(var(--foreground))',
                marginBottom: '0.5rem'
              }}>
                {cat.name}
              </div>
              
              <div className="flex items-center justify-between">
                <div style={{ 
                  fontSize: '2rem', 
                  fontWeight: 700,
                  fontFamily: 'monospace',
                  color: getHeatColor(cat.compositeScore)
                }}>
                  {Math.round(cat.compositeScore * 100)}
                </div>
                
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '0.5rem',
                  color: cat.trend === 'up' ? 'hsl(var(--success))' : 
                         cat.trend === 'down' ? 'hsl(var(--destructive))' : 'hsl(var(--muted-foreground))'
                }}>
                  {getTrendIcon(cat.trend)}
                  <span style={{ fontSize: '0.875rem', fontWeight: 600, fontFamily: 'monospace' }}>
                    {cat.delta >= 0 ? '+' : ''}{cat.delta.toFixed(1)}%
                  </span>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
